import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFormComponent } from '@shared/custom-form/custom-form/custom-form.component';
import {
  CustomFormElementComponent,
} from '@shared/custom-form/custom-form/custom-field-form-element/custom-form-element.component';
import { HauFormsModule } from '@sonofabit/ng-core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NebularModule } from '@shared/nebular/nebular.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import {
  GenericMultiControlComponent,
} from '@shared/custom-form/generic-multi-control/generic-multi-control.component';
import {
  GenericMultiControlTemplateDirective,
} from '@shared/custom-form/generic-multi-control/generic-multi-control-template.directive';
import { AttachmentUploadModule } from '@shared/form-controls/attachment-upload/attachment-upload.module';
import { TableFieldComponent } from '@shared/custom-form/table-field/table-field.component';
import { SignatureFieldComponent } from '@shared/custom-form/signature-field/signature-field.component';

@NgModule({
  declarations: [
    CustomFormComponent,
    CustomFormElementComponent,
    GenericMultiControlComponent,
    GenericMultiControlTemplateDirective,
    TableFieldComponent,
    SignatureFieldComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HauFormsModule,
    ReactiveFormsModule,
    PipesModule,
    NebularModule,
    AttachmentUploadModule,
  ],
  exports: [
    CustomFormComponent,
  ],
})
export class CustomFormModule {
}
